module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f074fc_logo_200x200.331e6dcd.png";